<script>
import Icon from '~/components/icon.vue';

export default {
  components: {
    Icon
  },

  props: {
    checked: {
      type: Boolean,
      required: true
    },

    disabled: {
      type: Boolean,
      required: true
    },

    code: {
      type: String,
      required: true
    },

    name: {
      type: String,
      required: true
    }
  },

  emits: ['update:payment-method'],

  computed: {
    labelFor() {
      return `payment_system_${this.code}`;
    },

    iconClass() {
      return `c-payment-methods__icon--${this.code}`;
    },
  },
};
</script>

<template>
  <div class="col-6 col-sm-4 col-md-6 col-lg-4">
    <label :for="labelFor">
      <input
        :id="labelFor"
        :value="code"
        :checked="checked"
        :disabled="disabled"
        type="radio"
        name="payment_system"
        autocomplete="off"
        @change="$emit('update:payment-method', code)"
      >

      <div class="c-payment-methods__item">
        <div class="c-checkmark c-payment-methods__item__checkmark">
          <icon
            name="check"
            size="small"
          />
        </div>

        <div class="d-flex flex-column align-items-center">
          <div
            :class="iconClass"
            class="my-2 c-payment-methods__icon"
          />

          <div class="text-center c-payment-methods__text">{{ name }}</div>
        </div>
      </div>
    </label>
  </div>
</template>
